<template>
    <div class="flex-row justify-center items-center bg-pink-300 py-24 px-10 lg:px-20 xl:px-32" id="career">
        <div class="w-full tablet:w-full lg:w-1/2 flex flex-col items-center md:flex-row md:items-start">
            <div class="w-full md:w-3/4 tablet:w-1/2 md:mr-10" id="who1">
                <h1 class="text-2xl md:text-4xl font-bold text-center text-white pb-8 uppercase">
                    {{ tr('career.lookingFor.title') }}
                </h1>
                <p class="text-white text-justify w-full"
                   v-html="tr('career.lookingFor.content')">
                </p>
            </div>

            <div class="w-full md:w-3/4 tablet:w-1/2 pt-10 md:pt-0" id="who2">
                <h1 class="text-2xl md:text-4xl font-bold text-center text-white pb-8 uppercase">
                    {{ tr('career.activities.title') }}
                </h1>
                <p class="text-white text-justify w-full"
                   v-html="tr('career.activities.content')">
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import {Translatable} from '@/data/translations';

export default {
    name: 'WhoAreWeLookingFor',
    mixins: [Translatable],
};
</script>

<style scoped>
#career {
    background-image: linear-gradient(to right, rgba(50, 50, 50, 0.95) 45%, rgba(50, 50, 50, 0.25)), url('../assets/img/whoAreWeLookingFor/whoAreWeLookingFor.jpg');
    background-position: left;
    background-repeat: no-repeat;
    background-size: cover;
}

@media (max-width: 1024px) {
    #career {
        background: linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url('../assets/img/whoAreWeLookingFor/whoAreWeLookingFor.jpg') no-repeat top center/cover;
    }
}
</style>
